import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'gs0071',
    ecrans: ['00-2'],
    params: ['id']
});
